/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueDto } from './concernsIssueDto.schema';

export const CreateConcernsIssue = zod.object({
  "payload": zod.lazy(() => ConcernsIssueDto).optional()
});

export type CreateConcernsIssue = zod.input<typeof CreateConcernsIssue>;
export type CreateConcernsIssueOutput = zod.output<typeof CreateConcernsIssue>;
